import { t } from 'i18next'
import { Button } from 'vnetwork-ui'
import { useModal } from '@/contexts/modal'
import NewFolderIcons from '@/icons/FolderIcons/NewFolderIcons'
import { ModifyObjectProps } from '@/modals/DriveModals/ModifyObjectModal'
import { ObjectType } from '@/modules/Drive/types'
export const customMenuItemStyle = 'hover:bg-secondary-20 text-sm gap-3'

const NewButton = () => {
    const { setModal } = useModal()

    return (
        <div>
            <Button
                onClick={() => {
                    setModal<ModifyObjectProps>(
                        'DriveModals/ModifyObjectModal/index',
                        {
                            title: t('create-folder-title'),
                            placeholder: t('create-folder-placeholder'),
                            type: ObjectType.FOLDER,
                        }
                    )
                }}
                startIcon={<NewFolderIcons className="text-[#626262]" />}
            >
                {t('create-folder-item')}
            </Button>
        </div>
    )
}

export default NewButton
